import { ClinicResponse } from './ClinicResponse';
import { SheetCode } from './Codes';

export enum SheetStatus {
  DRAFT = 'Draft',
  FINALIZED = 'Finalized',
  BILLED = 'Billed',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  PROCESSED = 'Processed',
  UPLOADED = 'Uploaded',
}

export type AIOutput = {
  icd10: string;
  modifiers: string;
  units: string;
  grants_choice: string;
};

export type SaveSheet = {
  scanText: string;
  scanDocumentUrl: string;
  sheetCodes: SheetCode[];
  name: string;
  createdAt: Date;
  sheetId: number;
  isFlagged: boolean;
  status: SheetStatus;
  documentName: string;
  updatedAt?: Date;
  clinicNote: boolean;
  clinicNoteResults: ClinicResponse | null;
  aiOutput: AIOutput | null;
  checkCodesUsed?: number;
};

export type SheetToSave = {
  scanText: string;
  scanDocumentUrl: string;
  sheetCodes: SheetCode[];
  name: string;
  status: SheetStatus;
  documentName: string;
  clinicNote: boolean;
  clinicNoteResults?: ClinicResponse | null;
  aiOutput?: AIOutput | null;
};

export interface UpdateSheetPayload extends SaveSheet {
  updateClinicNoteStatus?: boolean;
}
